import * as yup from 'yup'
import { APPConfig } from 'config/appConfig'
import {
  getEmailSchema,
  getPhoneSchema,
  getNameSchema,
  getOptionalPhoneNumberSchema,
} from 'src/deps'
import { getLocalStorage, convertToBoolean } from 'src/utils'

const userDetailsSchema = userResponse => {
  const phoneNumber = userResponse?.phoneNumber || ''
  const accountPhoneNumber = userResponse?.accounts?.phoneNumber || ''
  const userPhoneNumber = accountPhoneNumber || phoneNumber
  const accType = getLocalStorage('accountType')
  const enableJITSU = convertToBoolean(APPConfig.getAppConfig()?.enableJITSU)

  let schemaData = {}
  Object.assign(
    schemaData,
    getEmailSchema({
      inputName: 'email',
    })
  )

  if (enableJITSU) {
    Object.assign(
      schemaData,
      getOptionalPhoneNumberSchema({ inputName: 'mobilePhoneNumber' })
    )
  } else {
    Object.assign(
      schemaData,
      getPhoneSchema({ inputName: 'mobilePhoneNumber' })
    )
  }
  if (accType !== 'Brand Affiliate - Business Entity') {
    if (accType !== 'Brand Affiliate') {
      Object.assign(
        schemaData,
        getNameSchema(),
        getNameSchema({ isLastName: true, inputName: 'lastName' })
      )
    }
  }
  return yup.object(schemaData)
}

export { userDetailsSchema }
